import React, { Fragment } from 'react';
import i18n from "../../../i18next";
import { connect } from 'react-redux';
import { Container, Row, Col, Button, Label, Input } from 'reactstrap';
import MaterialIcon from 'material-icons-react';
import SectionTitle from '../customerInsightScreen/SectionTitle';
import LabeledToggleElement from './LabeledToggleElement';
import AvField from 'availity-reactstrap-validation/lib/AvField';
import { AvInput } from 'availity-reactstrap-validation';
import NavigationPanel from './NavigationPanel';
import { deleteTriggerImage, dispatchErrorMessage, loadListTriggerImages, uploadTriggerImage } from '../../../actions';
import { FRONT_END_URL } from '../../../utils/Constants';
import { arrayMove } from "react-sortable-hoc";


class EmailTemplateContainer extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            emailTemplate: {
                backgroundColor: '',
                backgroundImage: null,
                imageAsBackground: false,
                sections: [],
            },
            section: {
                id: null,
                imagePath: null,
                urlLink: '',
                textColor: null,
                textAlignment: null,
                fontSize: null,
                fontFamily: null,
                bold: false,
                italic: false,
                paragraph: null,
                fileName: null
            },
            isImageSection: true,
            isTextSection: false,
            isBackgroundSection: false,
            imagePreview: null,
            imageFormData: null,
            selectedImageIndex: null,
            selectedBackgroundImageIndex: null
        }

        this.reorderSectionItems = this.reorderSectionItems.bind(this);
        this.deleteSection = this.deleteSection.bind(this);
        this.editTextSection = this.editTextSection.bind(this);
    }

    componentDidMount() {
        this.props.loadListTriggerImages(this.props.restaurantId)
        const { trigger } = this.props.selectedMarketingAutomation;
        const { triggerImages } = this.props;

        if(trigger && trigger.emailTemplate) {

            this.setState({
                emailTemplate: {
                    ...this.state.emailTemplate,
                    backgroundImage: trigger.emailTemplate.backgroundImage,
                    backgroundColor: trigger.emailTemplate.backgroundColor,
                    sections: trigger.emailTemplate.sections,
                    imageAsBackground: trigger.emailTemplate.backgroundImage ? true : false
                }
            })
        }
    }

    componentDidUpdate(prevProps) {

        const { trigger } = this.props.selectedMarketingAutomation;
        const { triggerImages } = this.props;
        
        if(this.state.emailTemplate !== this.props.emailTemplate) {
            this.props.updateEmailTemplateState(this.state.emailTemplate)
        }

        if((triggerImages !== prevProps.triggerImages) && trigger && trigger.emailTemplate) {
            if(trigger.emailTemplate.backgroundImage && triggerImages && !this.state.selectedBackgroundImageIndex) {
                triggerImages.map((image, i) => {
                    if(image.imagePath === trigger.emailTemplate.backgroundImage) {
                        this.setState({
                            selectedBackgroundImageIndex: i
                        })
                    }
                })
            } 
        }
    }

    toggleSections(imageSection, textSection, backgroundSection) {

        if(imageSection) {

            this.setState({
                isImageSection: true,
                isTextSection: false,
                isBackgroundSection: false,
                section: {
                    id: null,
                    imagePath: null,
                    urlLink: '',
                    textColor: null,
                    textAlignment: null,
                    fontSize: null,
                    fontFamily: null,
                    bold: false,
                    italic: false,
                    paragraph: null,
                    fileName: null
                },
                selectedImageIndex: null,
            })

        } else if(textSection) {

            this.setState({
                isImageSection: false,
                isTextSection: true,
                isBackgroundSection: false,
                section: {
                    id: null,
                    imagePath: null,
                    urlLink: '',
                    textColor: null,
                    textAlignment: null,
                    fontSize: null,
                    fontFamily: null,
                    bold: false,
                    italic: false,
                    paragraph: null,
                    fileName: null
                },
                selectedImageIndex: null,
            })

        } else if(backgroundSection) {

            this.setState({
                isImageSection: false,
                isTextSection: false,
                isBackgroundSection: true,
                section: {
                    id: null,
                    imagePath: null,
                    urlLink: '',
                    textColor: null,
                    textAlignment: null,
                    fontSize: null,
                    fontFamily: null,
                    bold: false,
                    italic: false,
                    paragraph: null,
                    fileName: null
                },
                selectedImageIndex: null,
            })

        }
    }

    onChange = (e) => {

        this.setState({
            [e.target.name]: e.target.value,
        })
    }

    onChangeSectionState = (e) => {
        if(e.target.name === 'urlLink') {
            this.setState({
                section: {
                    ...this.state.section,
                    urlLink: e.target.value,
                    textColor: '',
                    textAlignment: '',
                    fontSize: '',
                    fontFamily: '',
                    bold: false,
                    italic: false,
                    paragraph: '',
                }
            })
        } else {
            this.setState({
                section: {
                    ...this.state.section,
                    [e.target.name]: e.target.value
                }
            })
        }
    }

    onChangeEmailTemplate = (e) => {
        this.setState({ 
            emailTemplate: {
                ...this.state.emailTemplate,
                [e.target.name]: e.target.value
        } });
    }

    onChangeBoldText = e => {
        this.setState({ 
            section: {
                ...this.state.section,
                bold: e.target.checked
        } });
    }

    onChangeItalicText = e => {
        this.setState({ 
            section: {
                ...this.state.section,
                italic: e.target.checked
        } });
    }

    onChangeImageAsBackground = e => {
        this.setState({ 
            emailTemplate: {
            ...this.state.emailTemplate,
            backgroundImage: null,
            backgroundColor: '',
            imageAsBackground: e.target.checked
            },
            selectedBackgroundImageIndex: null 
        });
    }

    negativeDecimalsValidation(e) {
        let inputKeyCode = e.keyCode ? e.keyCode : e.which;

        if (inputKeyCode != null) {
            if (inputKeyCode == 43 || inputKeyCode == 45 || inputKeyCode == 69
                || inputKeyCode == 101) e.preventDefault();
        }
    }

    resetTextSectionState() {
        this.setState({
            section: {
                ...this.state.section,
                id: null,
                urlLink: '',
                textColor: '',
                textAlignment: '',
                fontSize: '',
                fontFamily: '',
                bold: false,
                italic: false,
                paragraph: ''
            }
        })
    }

    resetBackgroundSectionState() {
        this.setState({
            emailTemplate: {
                ...this.state.emailTemplate,
                backgroundColor: '',
                backgroundImage: null,
                imageAsBackground: false
            },
            selectedBackgroundImageIndex: null
        })
    }

    resetImageSectionState() {
        this.setState({
            section: {
                ...this.state.section,
                imagePath: null,
                urlLink: ''
            },
            selectedImageIndex: null
        })
    }

    deleteSection(index) {
        const copyOfSections = this.state.emailTemplate.sections;
        
        copyOfSections.map((section, sectionIndex) => {
            if (sectionIndex === index) {
                copyOfSections.splice(index, 1);
            }

            this.setState({
                emailTemplate: {
                    ...this.state.emailTemplate,
                    sections: copyOfSections
                }
            })
        });
    }

    uploadImage(event) {
        event.preventDefault();
        const file = event.target.files[0];

        if (file.size > 10000000) {
            this.props.dispatchErrorMessage(`${i18n.t('common:validations.maximumImageSize')} 10MB`)
        } else {
            if (file !== undefined) {    // file === undefined when you click cancel
                this.setState({
                    ...this.state,
                    imagePreview: URL.createObjectURL(file),
                    imageFormData: event.target.files[0]
                }, () => {
                    this.props.uploadTriggerImage(this.props.restaurantId, this.state.imageFormData, () => {
                        this.props.loadListTriggerImages(this.props.restaurantId)
                    })
                });
            }
        }
    }

    selectImage(index, imagePath, fileName) {
        if (this.state.isBackgroundSection) {
            this.setState({
                emailTemplate: {
                    ...this.state.emailTemplate,
                    backgroundImage: index === this.state.selectedBackgroundImageIndex ? null : imagePath
                },
                selectedBackgroundImageIndex: index === this.state.selectedBackgroundImageIndex ? null : index,
            })
        } else {
            this.setState({
                section: {
                    urlLink: index === this.state.selectedImageIndex ? '' : this.state.section.urlLink,
                    imagePath: index === this.state.selectedImageIndex ? null : imagePath,
                    id: null,
                    textColor: '',
                    textAlignment: '',
                    fontSize: '',
                    fontFamily: '',
                    bold: false,
                    italic: false,
                    paragraph: '',
                    fileName: fileName
                },
                selectedImageIndex: index === this.state.selectedImageIndex ? null : index,
            })
        }
    }

    addTextAndImageSection() {
        
        let sections = this.state.emailTemplate.sections;
        let section = this.state.section;
        
        if(section.id) {
            if(sections && sections.length > 0) {
                sections.map((currentSection, i) => {
                    if(currentSection.id === section.id) {
                        sections.splice(i, 1, section);
                        this.setState({
                            emailTemplate: {
                                ...this.state.emailTemplate,
                                sections: sections
                            }
                        }, () => this.resetTextSectionState())
                    }
                })
            }
        } else if(this.state.isImageSection) {
            section.id = sections.length + 1;
            this.setState({
                emailTemplate: {
                    ...this.state.emailTemplate,
                    sections: [...sections, section]
                }
            }, () => this.resetImageSectionState())
        } else {
            section.id = sections.length + 1;
            this.setState({
                emailTemplate: {
                    ...this.state.emailTemplate,
                    sections: [...sections, section]
                }
            }, () => this.resetTextSectionState())
        }
    }

    editTextSection(currentSection) {
        this.toggleSections(false, true, false)
        this.setState({
            section: {
                imagePath: null,
                urlLink: '',
                id: currentSection.id,
                textColor: currentSection.textColor,
                textAlignment: currentSection.textAlignment,
                fontSize: currentSection.fontSize,
                fontFamily: currentSection.fontFamily,
                bold: currentSection.bold,
                italic: currentSection.italic,
                paragraph: currentSection.paragraph,
                fileName: null
            }
        })
    }

    renderFontOptions() {
        let fonts = ['arial narrow', 'Book Antiqua', 'Courier New', 'comic sans ms', 'monospace', 'Lucida Sans Unicode', 'roboto', 'tahoma' ];
        return fonts.map((font) => {
            return (
                <option style={{ fontFamily: font }} value={font}>{font}</option>
            )
        })
    }

    renderTextSectionButtons() {

        const { textSectionButtons } = styles;
        const isDisabledAddButtonTextSection = (this.state.section.paragraph === '') || (this.state.section.paragraph === null) || (this.state.section.paragraph === undefined);
        const isDisabledAddButtonImageSection = (this.state.section.imagePath === '') || (this.state.section.imagePath === null) || (this.state.section.imagePath === undefined);

        return (
            <div style={{ display: 'flex', justifyContent: 'flex-end', paddingRight: '15px' }}>
                <button disabled={this.state.isTextSection ? isDisabledAddButtonTextSection : isDisabledAddButtonImageSection} style={{ ...textSectionButtons, backgroundColor: '#1386c1', border: 'none' }} onClick={() => this.addTextAndImageSection()}>
                    {i18n.t('common:buttons.add')}
                </button>
                <div style={{ ...textSectionButtons, backgroundColor: '#9c9c9c' }} onClick={this.state.isImageSection ? () => this.resetImageSectionState() : () => this.resetTextSectionState()}>
                    {i18n.t('common:buttons.cancel')}
                </div>
            </div >
        );
    }

    renderBackgroundSectionButtons() {

        const { textSectionButtons } = styles;

        return (
            <div style={{ display: 'flex', justifyContent: 'flex-end', paddingRight: '15px' }}>
                <div style={{ ...textSectionButtons, backgroundColor: '#9c9c9c' }} onClick={() => this.resetBackgroundSectionState()}>
                    {i18n.t('common:buttons.cancel')}
                </div>
            </div >
        );
    }

    deleteTriggerImage(imageId) {

        this.props.deleteTriggerImage(imageId, () => {
            this.props.loadListTriggerImages(this.props.restaurantId)
        })
    }

    reorderSectionItems(oldIndex, newIndex) {
        const currentSections = this.state.emailTemplate.sections;

        this.setState({
            emailTemplate: {
                ...this.state.emailTemplate,
                sections: arrayMove(currentSections, oldIndex, newIndex)
            }
        })
    }

    renderTriggerImages() {
        const { triggerImages } = this.props;
        const { deleteImageIcon, activeImage, inactiveImage } = styles;
        
        if(triggerImages && triggerImages.length > 0) {
            return triggerImages.map((image, i) => {
                const isSelectedImage = this.state.selectedImageIndex === i;
                const isSelectedBackgroundImage = this.state.selectedBackgroundImageIndex === i;
                const selectedImageStyle = this.state.isBackgroundSection ? isSelectedBackgroundImage ? activeImage : inactiveImage : isSelectedImage ? activeImage : inactiveImage;
                const isDeleteImageOption = this.state.isBackgroundSection ? isSelectedBackgroundImage ? false : true : isSelectedImage ? false : true;
                return (
                    <Col sm={6} key={i} style={{marginBottom: '10px', padding: '0 5px'}}>
                        <img onClick={() => this.selectImage(i, image.imagePath, image.fileName)} style={selectedImageStyle} src={`${FRONT_END_URL}/${image.imagePath}`} />
                        {
                            isDeleteImageOption ?
                            <div onClick={() => this.deleteTriggerImage(image.id)} style={deleteImageIcon}><MaterialIcon icon="delete" color="rgb(2, 136, 209)" size={20} /></div> : null
                        }
                    </Col>
                )
            })
        }
    }

    renderImageSection() {
        const { emailTemplateBtnsStyle, emailTemplateItem } = this.props.styles;
        const { triggerImages } = this.props;

        return (
            <Fragment>
                <div style={emailTemplateItem}>
                    <div style={{display: 'flex', justifyContent: 'space-between', marginBottom: '10px'}}>
                        <SectionTitle title={i18n.t('screens:marketingAutomationScreen.images')} />
                        <input id="imagePreview" value={''} type="file" name="imagePreview" onChange={(event) => this.uploadImage(event)} style={{display: 'none'}} />
                        <Button color="primary" style={{...emailTemplateBtnsStyle, position: 'relative', right: '40px', top: '15px', alignItems: 'center'}} onClick={() => document.getElementById('imagePreview').click()}>
                        <span>{i18n.t('screens:marketingAutomationScreen.upload')}</span>
                        </Button>
                    </div>
                    {
                        this.state.emailTemplate.imageAsBackground && !this.state.emailTemplate.backgroundImage ?
                        <div style={{paddingLeft: '5px', color: 'rgb(244, 45, 35)', marginTop: '15px'}}>{i18n.t('screens:marketingAutomationScreen.backgroundImageReminder')}</div> : null
                    }
                    <Row sm={12} style={{display: 'flex', justifyContent: 'space-between', padding: '15px', maxHeight: '400px', overflowY: 'auto' }}>
                        {this.renderTriggerImages()}
                    </Row>
                </div>
                {
                    !this.state.isBackgroundSection ?
                        <Row sm={12} style={{margin: '10px 0'}}>
                            <input
                                type="text" 
                                name="urlLink" 
                                id="urlLink"
                                placeholder={i18n.t('screens:marketingAutomationScreen.redirectURL')}
                                style={{width: '100%', backgroundColor: 'rgb(242, 242, 242)', border: 'none', padding: '5px', height: '25px'}}
                                value={this.state.section.urlLink}
                                onChange={this.onChangeSectionState}
                                disabled={!this.state.section.imagePath}
                            />
                        </Row> : null
                }
            </Fragment>
        )
    }

    renderTextSection() {
        const { emailTemplateBtnsStyle, emailTemplateItem, emailTemplateInputStyle } = this.props.styles;
        const { section } = this.state;

        return (
            <div style={emailTemplateItem}>
                <div>
                    <SectionTitle title={i18n.t('screens:marketingAutomationScreen.text')} />
                    <Row style={{ margin: '0 0 10px 0' }}>
                    <Col sm={12} style={{display: 'flex', alignItems: 'center', marginTop: '10px'}}>
                            <Col sm={2}>
                                <Label for="textColor" >{i18n.t('screens:marketingAutomationScreen.textColor')}</Label>
                            </Col>
                            <Col sm={4}>
                                <AvField
                                    type="text" 
                                    name="textColor" 
                                    id="textColor"
                                    style={emailTemplateInputStyle}
                                    value={section.textColor}
                                    onChange={this.onChangeSectionState}
                                    placeholder="#FFFFFF"
                                />
                            </Col>
                            <Col sm={2}>
                                <Label for="textAlignment" >{i18n.t('screens:marketingAutomationScreen.alignment')}</Label>
                            </Col>
                            <Col sm={4}>
                                <AvField
                                    type="select" 
                                    name="textAlignment" 
                                    id="textAlignment"
                                    className="textAlignmentSelectField"
                                    style={{...emailTemplateInputStyle, padding: '5px 10px'}}
                                    placeholder={i18n.t('screens:marketingAutomationScreen.alignment')}
                                    value={section.textAlignment}
                                    onChange={this.onChangeSectionState}
                                >
                                    <option value=''></option>
                                    <option value={'left'}>{i18n.t('screens:marketingAutomationScreen.left')}</option>
                                    <option value={'right'}>{i18n.t('screens:marketingAutomationScreen.right')}</option>
                                    <option value={'center'}>{i18n.t('screens:marketingAutomationScreen.center')}</option>
                                </AvField>
                            </Col>
                        </Col>
                        <Col sm={12} style={{display: 'flex', alignItems: 'center', marginTop: '10px'}}>
                            <Col sm={2}>
                                <Label for="fontSize" >{i18n.t('screens:marketingAutomationScreen.textSize')}</Label>
                            </Col>
                            <Col sm={4}>
                                <AvField
                                    type="number" 
                                    name="fontSize" 
                                    id="fontSize"
                                    style={emailTemplateInputStyle}
                                    min={0}
                                    value={section.fontSize}
                                    onChange={this.onChangeSectionState}
                                    onKeyPress={(e) => this.negativeDecimalsValidation(e)}
                                />
                                <span style={{position: 'absolute', top: '5px', right: '45px', fontSize: '12px', color: 'rgb(149, 149, 149)'}}>px</span>
                            </Col>
                        </Col>
                        <Col sm={12} style={{display: 'flex', alignItems: 'center', marginTop: '10px'}}>
                            <Col sm={2}>
                                <Label for="fontFamily" >{i18n.t('screens:marketingAutomationScreen.textFamily')}</Label>
                            </Col>
                            <Col sm={6}>
                                <AvField
                                    type="select" 
                                    name="fontFamily" 
                                    id="fontFamily"
                                    style={{...emailTemplateInputStyle, fontFamily: section.fontFamily}}
                                    value={section.fontFamily}
                                    onChange={this.onChangeSectionState}
                                >
                                    <option value=''></option>
                                    {this.renderFontOptions()}
                                </AvField>
                            </Col>
                        </Col>
                        <Col sm={12} style={{display: 'flex', alignItems: 'center', padding: '0 30px', marginTop: '10px'}}>
                            <Col sm={4} style={{ padding: 0 }}>
                                <LabeledToggleElement
                                    icon={null}
                                    text={i18n.t('screens:marketingAutomationScreen.bold')}
                                    toggleChecked={section.bold}
                                    toggleOnChange={this.onChangeBoldText}
                                    spaceBetween={5}
                                    flexEnd={false}
                                    editMode={false}
                                />
                            </Col>
                            <Col sm={4} style={{ padding: 0 }}>
                                <LabeledToggleElement
                                    icon={null}
                                    text={i18n.t('screens:marketingAutomationScreen.italic')}
                                    toggleChecked={section.italic}
                                    toggleOnChange={this.onChangeItalicText}
                                    spaceBetween={5}
                                    flexEnd={false}
                                    editMode={false}
                                />
                            </Col>
                        </Col>
                        <Col sm={12} style={{margin: '20px 0px 0px 0px', padding: '0 30px', fontSize: '13px'}}>
                            <div>
                                {i18n.t('screens:marketingAutomationScreen.emailTemplateInfoMsg')}
                            </div>
                        </Col>
                        <Col sm={12} style={{margin: '3px 0px 20px 0px', height: '200px', padding: '0 30px'}}>
                            <AvInput
                                style={{width: '100%', height: '100%', borderRadius: '5px'}}
                                placeholder={i18n.t('screens:marketingAutomationScreen.addText')}
                                type="textarea" 
                                name="paragraph" 
                                id="paragraph"
                                value={section.paragraph}
                                onChange={this.onChangeSectionState}
                            />
                        </Col>
                    </Row>
                </div>
            </div>
        )
    }

    renderBackgroundSection() {
        const { emailTemplateBtnsStyle, emailTemplateItem, emailTemplateInputStyle } = this.props.styles;
        const { section, emailTemplate } = this.state;

        return (
            <div style={emailTemplateItem}>
                <div>
                    <SectionTitle title={i18n.t('screens:marketingAutomationScreen.background')} />
                    <Row style={{ margin: '0 0 10px 0' }}>
                        <Col sm={12} style={{display: 'flex', alignItems: 'center', marginTop: '20px'}}>
                            <Col sm={2}>
                                <Label for="backgroundColor" >{i18n.t('screens:marketingAutomationScreen.color')}</Label>
                            </Col>
                            <Col sm={6}>
                                <AvField
                                    type="text" 
                                    name="backgroundColor" 
                                    id="backgroundColor"
                                    style={{...emailTemplateInputStyle, maxWidth: '150px'}}
                                    value={emailTemplate.backgroundColor}
                                    onChange={this.onChangeEmailTemplate}
                                    disabled={emailTemplate.imageAsBackground}
                                    placeholder="#FFFFFF"
                                />
                            </Col>
                        </Col>
                        <Col sm={12} style={{display: 'flex', padding: '0 30px', marginTop: '10px'}}>
                            <Col sm={6} style={{ padding: 0, marginRight: '10px' }}>
                                <LabeledToggleElement
                                    icon={null}
                                    text={i18n.t('screens:marketingAutomationScreen.useImageAsBackground')}
                                    toggleChecked={emailTemplate.imageAsBackground}
                                    toggleOnChange={this.onChangeImageAsBackground}
                                    spaceBetween={5}
                                    flexEnd={false}
                                    editMode={false}
                                />
                            </Col>
                        </Col>
                    </Row>
                </div>
                {
                    emailTemplate.imageAsBackground ?
                    <div style={{backgroundColor: '#fff'}}>{this.renderImageSection()}</div> : null
                }
            </div>
        )
    }

    renderEmailTemplate() {
        const { sectionDiv, emailTemplateBtnsTextStyle, emailTemplateBtnsStyle, activeBtnStyle } = this.props.styles;
        const { isImageSection, isTextSection, isBackgroundSection } = this.state;

        return (
            <div style={sectionDiv}>
                <div>
                    <SectionTitle title={i18n.t('screens:marketingAutomationScreen.emailTemplate')} />
                </div>
                <Col style={{display: 'flex', margin: '15px 0', padding: '10px 30px'}}>
                    <button onClick={() => this.toggleSections(true, false, false)} className="emailTemplateBtn" color="primary" style={isImageSection ? {...emailTemplateBtnsStyle, ...activeBtnStyle} : emailTemplateBtnsStyle}>
                        <span style={{ display: 'flex', alignSelf: 'center' }}><MaterialIcon icon="add" color="#fff" size={18} /></span>
                        <span style={emailTemplateBtnsTextStyle}>{i18n.t('screens:marketingAutomationScreen.addImage')}</span>
                    </button>
                    <button onClick={() => this.toggleSections(false, true, false)} className="emailTemplateBtn" color="primary" style={isTextSection ? {...emailTemplateBtnsStyle, ...activeBtnStyle, marginLeft: '15px'} : {...emailTemplateBtnsStyle, marginLeft: '15px'}}>
                        <span style={{ display: 'flex', alignSelf: 'center' }}><MaterialIcon icon="add" color="#fff" size={18} /></span>
                        <span style={emailTemplateBtnsTextStyle}>{i18n.t('screens:marketingAutomationScreen.addText')}</span>
                    </button>
                    <button onClick={() => this.toggleSections(false, false, true)} className="emailTemplateBtn" color="primary" style={isBackgroundSection ? {...emailTemplateBtnsStyle, ...activeBtnStyle, marginLeft: '15px'} : {...emailTemplateBtnsStyle, marginLeft: '15px'}}>
                        <span style={emailTemplateBtnsTextStyle}>{i18n.t('screens:marketingAutomationScreen.background')}</span>
                    </button>
                </Col>
                <Col>
                    {
                        isImageSection ? 
                        <div>
                            {this.renderImageSection()}
                            {this.renderTextSectionButtons()}
                            </div> : null
                    }
                    {
                        isTextSection ? 
                        <div>
                            {this.renderTextSection()}
                            {this.renderTextSectionButtons()}
                        </div> : null
                    }
                    {
                        isBackgroundSection ? 
                        <div>
                            {this.renderBackgroundSection()}
                            {this.renderBackgroundSectionButtons()}
                        </div> : null
                    }
                </Col>
            </div>
        )
    }

    render() {

        return (
            <Row xs={12} md={12}>
                <Col xs={5} md={5} style={{paddingRight: '0px'}}>
                    {this.renderEmailTemplate()}
                </Col>
                <Col xs={7} md={7} style={{paddingLeft: '5px'}}>
                    <NavigationPanel
                        styles={this.props.styles}
                        reorderSectionItems={this.reorderSectionItems}
                        deleteSection={this.deleteSection}
                        emailTemplate={this.state.emailTemplate}
                        editTextSection={this.editTextSection}
                    />
                </Col>
            </Row>
        )
    }
}

const mapStateToProps = state => {
    return {
        marketingAutomations: state.marketingAutomations,
        triggerImages: state.triggerImages
    }
};

export default connect(mapStateToProps, {uploadTriggerImage, loadListTriggerImages, deleteTriggerImage, dispatchErrorMessage})(EmailTemplateContainer);

const styles = {
    textSectionButtons: {
        borderRadius: '15px',
        padding: '0 15px 0 15px',
        margin: '0 10px 0 0',
        color: 'white',
        cursor: 'pointer',
        fontSize: '16px'
    },
    deleteImageIcon: {
        display: 'flex',
        width: '20px',
        height: '20px',
        position: 'absolute', 
        top: '5px', 
        right: '20px', 
        backgroundColor: '#fff', 
        borderRadius: '20px',
        cursor: 'pointer'
    },
    activeImage: {
        width: '100%',
        border: '4px solid red'
    },
    inactiveImage: {
        width: '100%',
        opacity: '0.4'
    }
}


// WEBPACK FOOTER //
// ./src/components/restaurants/marketingAutomations/EmailTemplateContainer.js